import { NICmsContentField } from '@icms/core/content';
import findIndex from 'lodash-es/findIndex';
import { NBloomreach } from '../../../../../module/bloomreach/bloomreach.namespace';
import { ILocalModelCarouselData } from '../local-model-carousel/local-model-carousel.interface';

export function addBloomreachRecommendationsVariant(fields: NICmsContentField.IField[]): NICmsContentField.IField[] {
    const variantIndex = findIndex(fields, i => i.key === 'variant');

    if (variantIndex) {
        const variant = fields[variantIndex] as NICmsContentField.IChoiceField;

        if (Array.isArray(variant?.options)) {
            const key: string = NBloomreach.RECOMMENDATIONS_ENGINE_ID;

            variant.options.push({ key, title: 'Bloomreach Recommendations' });

            const optionsField: NICmsContentField.IField = {
                key: NBloomreach.RECOMMENDATIONS_OPTIONS,
                type: NICmsContentField.EFieldType.textarea,
                title: 'Bloomreach Recommendations Options',
                canShow: (data: ILocalModelCarouselData) => data?.variant === key
            };

            fields.splice(variantIndex + 1, 0, optionsField);
        }
    }

    return fields;
}
